import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { neverError } from '@seu-helpers';
import { SEU_LANGUAGE_DEFAULT, SeuLanguage } from '@seu-types';
import { setDefaultOptions } from 'date-fns';
import { de, enGB } from 'date-fns/locale';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly translate = inject(TranslateService);

  private readonly language$$ = new BehaviorSubject<SeuLanguage | undefined>(
    undefined
  );

  public setLang(lang: SeuLanguage): void {
    this.translate.use(this.getLocaleForLang(lang));

    // setting datefns locale
    switch (lang) {
      case 'DE':
        setDefaultOptions({ locale: de });
        break;
      case 'EN':
        setDefaultOptions({ locale: enGB });
        break;
      default:
        throw neverError(lang);
    }

    this.language$$.next(lang);
  }

  public getLang(): SeuLanguage {
    return this.language$$.getValue() ?? SEU_LANGUAGE_DEFAULT;
  }

  private getLocaleForLang(lang: SeuLanguage): string {
    switch (lang) {
      case 'DE':
        return 'de-DE';
      case 'EN':
        return 'en-GB';
      default:
        throw neverError(lang);
    }
  }
}
